import { PropTypes } from 'prop-types';
import { useState } from 'react';
import ModelButton from '../modelBtn/modelButton';
import PopUp from './happening/popUp';

const Happening = ({ happening }) => {
    const [modalOpen, setModalOpen] = useState(false);

    const closed = () => setModalOpen(false);
    const open = () => setModalOpen(true);

    // Extract plain text from richTextContent.markup for description
    const getPlainTextDescription = (markup) => {
        const div = document.createElement('div');
        div.innerHTML = markup;
        return div.textContent.substring(0, 100) + '...read more';
    };

    const description = happening?.properties?.richTextContent?.markup 
        ? getPlainTextDescription(happening.properties.richTextContent.markup)
        : 'No description available';

    return (
        happening?.properties?.richTextContent?.markup ? (
            <>
                <div
                    onClick={() => (modalOpen ? closed() : open())}
                    className="flex shrink-0 flex-col justify-between gap-5 p-8 border shadow-md rounded-lg w-[21rem] h-[24.15rem] cursor-pointer"
                >
                    <div className="flex flex-col gap-5 flex-grow">
                        <h3 className="w-auto text-[#337AB7] text-[1.13rem] font-bold h-12">
                            published on {new Date(happening.properties.publishedDate).toLocaleDateString('en-GB', {
                                day: '2-digit',
                                month: 'long',
                                year: 'numeric'
                            })}
                        </h3>
                        <h3 className="w-auto text-zinc-950 text-xl font-bold uppercase">
                            {happening.properties.title}
                        </h3>
                    </div>
                    <div className="grid place-items-start gap-5 py-4 border-t-2 border-t-[#C4C4C4]">
                        <p className="w-auto text-justify text-base font-medium line-clamp-3">
                            {description}
                        </p>
                    </div>
                </div>
                <ModelButton modalOpen={modalOpen} close={closed}>
                    <PopUp
                        title={happening.properties.title}
                        date={new Date(happening.properties.publishedDate).toLocaleDateString('en-GB', {
                            day: '2-digit',
                            month: 'long',
                            year: 'numeric'
                        })}
                        description={<div dangerouslySetInnerHTML={{ __html: happening.properties.richTextContent.markup }} />}
                    />
                </ModelButton>
            </>
        ) : (
            <div className="flex shrink-0 flex-col justify-between gap-5 p-8 border shadow-md rounded-lg w-[21rem] h-[24.15rem]">
                <div className="flex flex-col gap-5 flex-grow">
                    <h3 className="w-auto text-[#337AB7] text-[1.13rem] font-bold h-12 line-clamp-2">
                        published on {new Date(happening.properties.publishedDate).toLocaleDateString('en-GB', {
                            day: '2-digit',
                            month: 'long',
                            year: 'numeric'
                        })}
                    </h3>
                    <h3 className="w-auto text-zinc-950 text-xl font-bold uppercase">
                        {happening.properties.title}
                    </h3>
                </div>
                <div className="grid place-items-start gap-5 py-4 border-t-2 border-t-[#C4C4C4]">
                    <p className="w-auto text-justify text-base font-medium line-clamp-3">
                        {description}
                    </p>
                </div>
            </div>
        )
    );
};

Happening.propTypes = {
    happening: PropTypes.object,
};

export default Happening;